module.exports = __webpack_public_path__ + "img/logo_lc_service_srl.9016ef1e.png";